import * as ActionConfigurationManager from './config.actions';

export const showPreferenceCenterInlineLoader = ActionConfigurationManager.SHOW_PREFERENCE_CENTER_INLINE_LOADER;
export const hidePreferenceCenterInlineLoader = ActionConfigurationManager.HIDE_PREFERENCE_CENTER_INLINE_LOADER;
export const preferenceCenterEmailFound = ActionConfigurationManager.PREFERENCE_CENTER_EMAIL_FOUND
export const preferenceCenterNoEmailFound = ActionConfigurationManager.PREFERENCE_CENTER_NO_EMAIL_FOUND